// mutation types
const SET_DAY_VALUE = "SET_DAY_VALUE";
const SET_TIME_SHEETS = "SET_TIME_SHEETS";
const SET_START_HOLE = "SET_START_HOLE";
const SET_START_HOLE_SORT = "SET_START_HOLE_SORT";
const SET_PRESET_DATE = "SET_PRESET_DATE";
const SET_FLIGHT_TIME_FILTER = "SET_FLIGHT_TIME_FILTER";
const SET_SHOW_HOME_CLUB = "SET_SHOW_HOME_CLUB";
const SET_SINGLE_HOLE_MODE = "SET_SINGLE_HOLE_MODE";
const SET_SELECTED_SINGLE_HOLE = "SET_SELECTED_SINGLE_HOLE";
const SET_REALOADING = "SET_REALOADING";

// initial state
const state = () => ({
  dayValue: null,
  timeSheets: null,
  startHole: null,
  startHoleSort: null,
  presetDate: null,
  flightTimeLimit: null,
  showHomeClub: false,
  singleHoleMode: false,
  selectedSingleHole: null,
  reloading: false,
});

// getters
const getters = {
  getDayValue(state) {
    return state.dayValue;
  },
  getTimeSheets(state) {
    return state.timeSheets;
  },
  getStartHole(state) {
    return state.startHole;
  },
  getStartHoleSort(state) {
    return state.startHoleSort;
  },
  getPresetDate(state) {
    return state.presetDate;
  },
  getFlightTimeLimit(state) {
    return state.flightTimeLimit;
  },
  getShowHomeClub(state) {
    return state.showHomeClub;
  },
  getSingleHoleMode(state) {
    return state.singleHoleMode;
  },
  getSelectedSingleHole(state) {
    return state.selectedSingleHole;
  },
  getReloading(state) {
    return state.reloading;
  },
};

// actions
const actions = {
  setDayValue({ commit }, payload) {
    commit(SET_DAY_VALUE, payload);
  },
  setTimeSheets({ commit }, payload) {
    commit(SET_TIME_SHEETS, payload);
  },
  setStartHole({ commit }, payload) {
    commit(SET_START_HOLE, payload);
  },
  setStartHoleSort({ commit }, payload) {
    commit(SET_START_HOLE_SORT, payload);
  },
  setPresetDate({ commit }, payload) {
    commit(SET_PRESET_DATE, payload);
  },
  setFlightTimeLimit({ commit }, payload) {
    commit(SET_FLIGHT_TIME_FILTER, payload);
  },
  setShowHomeClub({ commit }, payload) {
    localStorage.setItem("show_home_club", payload);
    commit(SET_SHOW_HOME_CLUB, payload);
  },
  setSingleHoleMode({ commit }, payload) {
    localStorage.setItem("single_hole_mode", payload);
    commit(SET_SINGLE_HOLE_MODE, payload);
  },
  setSelectedSingleHole({ commit }, payload) {
    commit(SET_SELECTED_SINGLE_HOLE, payload);
  },
  setReloading({ commit }, payload) {
    commit(SET_REALOADING, payload);
  },
};

// mutations
const mutations = {
  [SET_DAY_VALUE](state, dayValue) {
    state.dayValue = dayValue;
  },
  [SET_TIME_SHEETS](state, timeSheets) {
    state.timeSheets = timeSheets;
  },
  [SET_START_HOLE](state, startHole) {
    state.startHole = startHole;
  },
  [SET_START_HOLE_SORT](state, startHoleSort) {
    state.startHoleSort = startHoleSort;
  },
  [SET_PRESET_DATE](state, presetDate) {
    state.presetDate = presetDate;
  },
  [SET_FLIGHT_TIME_FILTER](state, flightTimeLimit) {
    state.flightTimeLimit = flightTimeLimit;
  },
  [SET_SHOW_HOME_CLUB](state, showHomeClub) {
    state.showHomeClub = showHomeClub;
  },
  [SET_SINGLE_HOLE_MODE](state, singleHoleMode) {
    state.singleHoleMode = singleHoleMode;
  },
  [SET_SELECTED_SINGLE_HOLE](state, selectedSingleHole) {
    state.selectedSingleHole = selectedSingleHole;
  },
  [SET_REALOADING](state, reloading) {
    state.reloading = reloading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
